import { FetchClient } from "../utils/fetchClient";

export const fetchMessageBlocks = async () => {
    return FetchClient(`/data/message-blocks`).GET({})
}